import {AREA_PATTERN, ASSET_FIELD_MAX_LENGTHS} from '@sollapay/domain/asset-types';

import type {AssetFieldKey} from '@sollapay/domain/asset-types';
import type {IconName} from '@sollapay/ui';

/** Exhaustive — a new AssetFieldKey is a compile error here until given an icon. */
export const ASSET_FIELD_ICONS: Record<AssetFieldKey, IconName> = {
  buildingNumber: 'building',
  unitNumber: 'hash',
  address: 'marker-pin',
  floor: 'grid',
  block: 'grid',
  parcel: 'hash',
  subParcel: 'hash',
  area: 'grid',
  description: 'file'
};

interface AssetFieldConstraint {
  /** Rejects anything the column cannot store, or that the server would reject. */
  pattern?: RegExp;
  errorKey: string;
  maxLength?: number;
}

/** A key absent here accepts any text — the server still has the final say. */
export const ASSET_FIELD_CONSTRAINTS: Partial<Record<AssetFieldKey, AssetFieldConstraint>> = {
  area: {pattern: AREA_PATTERN, errorKey: 'common:fields.area.invalid'},
  buildingNumber: {
    maxLength: ASSET_FIELD_MAX_LENGTHS.buildingNumber,
    errorKey: 'common:tooLong'
  },
  unitNumber: {
    maxLength: ASSET_FIELD_MAX_LENGTHS.unitNumber,
    errorKey: 'common:tooLong'
  },
  address: {maxLength: 500, errorKey: 'common:tooLong'}
};
